import { getChatApiBase, getChatApiHeaders } from './chatApiClient'
import axios from './axiosInstance'

export async function list(app, apiHost, pageNo = 1, limit = 10) {
  const URL = `${getChatApiBase(app, apiHost)}/ai/personalities?per_page=${limit}&page=${pageNo}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function add(post, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/ai/personalities`
  return axios
    .post(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function get(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/ai/personalities/${id}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function update(id, post, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/ai/personalities/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function del(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/ai/personalities/${id}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}
